import "./../styles/main.scss";
// JQuery Ecosystem
import $ from "jquery";
require("./helpers/jQueryPlugins");
require("jquery.scrollto");
// import TomSelect from "tom-select";
import Isotope from "isotope-layout";
// Transition Ecosystem
// import barba from '@barba/core';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import transitionEffect from "./helpers/transitionEffect";
gsap.registerPlugin(ScrollTrigger);
var te = new transitionEffect();
// Ui item
import GLightbox from "glightbox";
import { carouselWrapper } from "./helpers/CarouselWrapper";
import { Loader } from '@googlemaps/js-api-loader';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
// Woocommerce
// require('./woocommerce/Global');
// GDPR Custom System
require('./helpers/CookieConsent');
// Controllers
// require("./helpers/newsletterController");
let markers = [];
// Define all actions
let Site = {
    // Plugins
    carousel: carouselWrapper,
    // Actions
    init: () => {
        Site.global();
    },
    transition: (response) => {
        Site.global();
        Site.scripts(response);
    },
    global: () => {
        Site.carousel();
        GLightbox({
        // touchNavigation: false,
        // touchFollowAxis: false,
        // keyboardNavigation: false,
        });
    },
    scripts: (response) => {
        var initialized_scripts = [];
        var script_tags = document.getElementsByTagName("script");
        $(script_tags).each(function (i, s) {
            var src = $(s).attr('src');
            if (src) {
                initialized_scripts.push(src);
            }
        });
        var new_imports = [];
        var new_evaluations = '';
        var script_tags = $(response).find('script');
        $(script_tags).each(function (i, s) {
            var src = $(s).attr('src');
            if (src) {
                // if not already initialized add it
                if (initialized_scripts.indexOf(src) == -1) {
                    new_imports.push(src);
                }
            }
            else {
                // it is an inline script, will evaluate it
                new_evaluations += script_tags[i].innerHTML;
            }
        });
        $.getMultiScripts(new_imports).done(function () {
            eval(new_evaluations);
        }).fail(function (error) {
            // one or more scripts failed to load
        }).always(function () {
            // always called, both on success and error
        });
    }
};
// barba.init({
//     views: [],
//     transitions: [{
//         name: 'opacity-transition',
//         async leave({ current, next, trigger }) {
//             const done = this.async();
//             $('.show-menu').removeClass("show-menu");
//             te.toggle().eventCallback("onComplete", () => {
//                 gsap.to(current.container, {
//                     opacity: 0
//                 }).eventCallback("onComplete", () => {
//                     done();
//                 });
//             });;
//         },
//         after(data) {
//             let parser = new DOMParser();
//             let htmlDoc = parser.parseFromString(data.next.html.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', data.next.html), 'text/html');
//             let bodyClasses = htmlDoc.querySelector('notbody').getAttribute('class');
//             let dataPid = $(htmlDoc).find('notbody').data("pid");
//             document.body.setAttribute('class', bodyClasses);
//             $(window).scrollTo(0);
//             $("#main-header").find(".current-menu-item").removeClass("current-menu-item");
//             let newMenu = $("#main-header").find(".menu-item[data-pid="+ dataPid +"]");
//             if (newMenu.length) {
//                 newMenu.addClass("current-menu-item");
//             }
//             gsap.from(data.next.container, {
//                 opacity: 0
//             });
//             te.toggle().eventCallback("onComplete", () => {
//                 te.removeScreen();
//                 Site.transition(htmlDoc);
//             });
//         }
//     }]
// });
$.expr[':'].contains = function (a, i, m) {
    return $(a).text().toUpperCase()
        .indexOf(m[3].toUpperCase()) >= 0;
};
$(document).ready(function () {
    Site.init();
    if ($("section[data-project]").length) {
        $("#nf-field-21").val($("section[data-project]").attr("data-project"));
    }
    $.extend($.scrollTo.defaults, {
        axis: 'y'
    });
    $("body").on("click", "a[data-goto]", (e) => {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href").replace("/", "");
        if (node.length) {
            const posY = $(node).offset().top - $("#main-header").height();
            if (posY >= 0) {
                $.scrollTo(posY, 400);
            }
        }
    });
    $("body").on("click", ".opener", (e) => {
        e.preventDefault();
        $(e.currentTarget).toggleClass("opened");
        $(e.currentTarget).parent().next().slideToggle(250);
    });
    $('body').on("click", ".shared-item", (e) => {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", (e) => {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $("body").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", "#nav-main a", (e) => {
        $("#nav-main").removeClass("show-menu");
        $("body").removeClass("show-menu");
        $("#menu-switcher a").removeClass("show-menu");
    });
    $("body").on("click", ".goTo, [href^='#']:not(.glightbox)", (e) => {
        const elm = $(e.currentTarget).attr("href");
        if ($(elm).length) {
            const posY = $(elm).offset().top - ($("#main-header").height() + 20);
            $.scrollTo(posY, 400);
        }
    });
    $("body").on("click", ".scrollto.address", (e) => {
        const elm = "#map-holder";
        if ($(elm).length) {
            const posY = $(elm).offset().top - ($("#main-header").height() + 20);
            $.scrollTo(posY, 400);
        }
    });
    $("body.page-template-tpl-home").on("click", "[href^='/#']:not(.glightbox)", (e) => {
        const elm = $(e.currentTarget).attr("href").replace("/", "");
        if ($(elm).length) {
            const posY = $(elm).offset().top - ($("#main-header").height() + 20);
            $.scrollTo(posY, 400);
        }
    });
    if ($('.gallery-grid').length) {
        let iso = new Isotope(".gallery-grid", {
            itemSelector: '.gallery-item',
            layoutMode: 'masonry',
            percentPosition: true,
            getSortData: {
                price: function (itemElem) {
                    var price = $(itemElem).attr("data-price");
                    return parseFloat(price);
                },
                date: function (itemElem) {
                    var item = $(itemElem).attr("data-date");
                    return parseFloat(item);
                },
            },
            masonry: {
                columnWidth: '.gallery-item',
                gutter: 15
            },
            sortBy: "price",
            isAscending: true
        });
        setTimeout(() => {
            iso.layout();
        }, 2000);
        $('.sort-by-button-group').on('click', 'button', function (e) {
            $('.sort-by-button-group').find(".is-checked").removeClass("is-checked");
            $(e.currentTarget).addClass("is-checked");
            var sortValue = $(e.currentTarget).attr('data-sort-value');
            var sortDirection = true;
            if ($(e.currentTarget).attr('data-sort-direction') !== void 0)
                sortDirection = $(e.currentTarget).attr('data-sort-direction') == "asc" ? true : false;
            iso.arrange({ sortBy: sortValue, sortAscending: sortDirection });
        });
    }
    var lastScrollTop = 0;
    let scrollFn = function () {
        var st = $(window).scrollTop();
        if (st > 250) {
            $('#main-header').addClass('scrolled');
        }
        else {
            $('#main-header').removeClass('scrolled');
        }
        lastScrollTop = st;
    };
    $(window).scroll(scrollFn);
    // $("select").each((k, v) => {
    //     var settings = {};
    //     new TomSelect(v,settings);
    // });
    scrollFn.call(null);
    $("body").on("click", "*[data-link]", (e) => {
        document.location = $(e.currentTarget).attr("data-link");
    });
    if ($("#map").length) {
        const apiKey = $("#map").attr("data-uid");
        const loader = new Loader({
            apiKey: apiKey,
            version: "weekly",
            libraries: []
        });
        let zoom = 7;
        let center = {
            lat: 38.143198,
            lng: -2.821030
        };
        if ($("#map").attr("data-zoom") !== void 0) {
            zoom = parseInt($("#map").attr("data-zoom"));
        }
        if ($("#map").attr("data-lat") !== void 0) {
            center = {
                lat: parseFloat($("#map").attr("data-lat")),
                lng: parseFloat($("#map").attr("data-lng"))
            };
        }
        let mapStyled = [{ "featureType": "all", "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 20 }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{ "color": "#c0eea4" }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e9e9" }, { "lightness": 17 }] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#a6edf1" }] }];
        const mapOptions = {
            center: center,
            zoom: zoom,
            mapTypeControl: false,
            fullscreenControl: false,
            styles: mapStyled
        };
        loader
            .load()
            .then((google) => {
            let map = new google.maps.Map(document.getElementById("map"), mapOptions);
            //
            createMarkers(google, map);
            // let groups = { category: [], status: [] };
        });
    }
    if ($("#search-form-faq").length) {
        $('.close-btn').on("click", (e) => {
            e.preventDefault();
            $('.found').removeClass("found");
            $('.results').html("");
            $('.close-btn').addClass("hidden");
        });
        $("#search-form-faq").on("submit", (e) => {
            e.preventDefault();
            let value = $("#search-form-faq .search-box").val();
            // Remove all classes
            // $(".opener.found").removeClass("opened");
            // $(".bottle.found").removeClass("shown");
            $('.found').removeClass("found");
            //
            if (value != "") {
                $('.close-btn').removeClass("hidden");
                $("#questions").addClass("found");
                let elm = $(".question:contains('" + value + "')");
                elm.addClass("found");
                let gf = elm.parents(".category");
                gf.addClass("found");
                gf.children("h2").children("a").addClass("found");
                gf.children(".bottle").addClass("found");
                $('.results').html("Élément(s) trouvé(s) pour le terme '" + value + "': " + elm.length + "");
            }
            else {
                $('.close-btn').addClass("hidden");
                $('.results').html("");
            }
        });
    }
    setTimeout(() => {
        $(window).trigger('resize');
    }, 800);
    function createslider(element) {
        const inputs = element.querySelectorAll('input');
        const thumbLeft = element.querySelector('.thumb.left');
        const thumbRight = element.querySelector('.thumb.right');
        const rangeBetween = element.querySelector('.range-between');
        const labelMin = element.querySelector('.range-label-start');
        const labelMax = element.querySelector('.range-label-end');
        const [inputStart, inputEnd] = inputs;
        const min = parseInt(inputStart.value);
        const max = parseInt(inputEnd.value);
        setStartValueCustomSlider(inputStart, inputEnd, thumbLeft, rangeBetween);
        setEndValueCustomSlider(inputEnd, inputStart, thumbRight, rangeBetween);
        setEvents(inputStart, inputEnd, thumbLeft, thumbRight, labelMin, labelMax, rangeBetween);
    }
    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
    function setLabelValue(label, input) {
        label.innerHTML = `${numberWithCommas(input.value)} €`;
    }
    function setStartValueCustomSlider(inputStart, inputEnd, pseudoEl, range) {
        const maximum = Math.min(parseInt(inputStart.value), parseInt(inputEnd.value) - 1);
        const percent = ((maximum - inputStart.min) / (inputStart.max - inputStart.min)) * 100;
        pseudoEl.style.left = percent + '%';
        range.style.left = percent + '%';
    }
    function setEndValueCustomSlider(inputEnd, inputStart, pseudoEl, range) {
        const minimun = Math.max(parseInt(inputEnd.value), parseInt(inputStart.value) + 1);
        const percent = ((minimun - inputEnd.min) / (inputEnd.max - inputEnd.min)) * 100;
        pseudoEl.style.right = 100 - percent + '%';
        range.style.right = 100 - percent + '%';
    }
    function setEvents(inputStart, inputEnd, thumbLeft, thumbRight, labelMin, labelMax, rangeBetween, rangesValues) {
        inputStart.addEventListener('input', () => {
            setStartValueCustomSlider(inputStart, inputEnd, thumbLeft, rangeBetween);
            setLabelValue(labelMin, inputStart);
        });
        inputEnd.addEventListener('input', () => {
            setEndValueCustomSlider(inputEnd, inputStart, thumbRight, rangeBetween);
            setLabelValue(labelMax, inputEnd);
        });
        // add css clases on hover and drag
        inputStart.addEventListener('mouseover', function () {
            thumbLeft.classList.add('hover');
        });
        inputStart.addEventListener('mouseout', function () {
            thumbLeft.classList.remove('hover');
        });
        inputStart.addEventListener('mousedown', function () {
            thumbLeft.classList.add('active');
        });
        inputStart.addEventListener('pointerup', function () {
            thumbLeft.classList.remove('active');
        });
        inputEnd.addEventListener('mouseover', function () {
            thumbRight.classList.add('hover');
        });
        inputEnd.addEventListener('mouseout', function () {
            thumbRight.classList.remove('hover');
        });
        inputEnd.addEventListener('mousedown', function () {
            thumbRight.classList.add('active');
        });
        inputEnd.addEventListener('pointerup', function () {
            thumbRight.classList.remove('active');
        });
        // Mobile
        inputStart.addEventListener('touchstart', function () {
            thumbLeft.classList.add('active');
        });
        inputStart.addEventListener('touchend', function () {
            thumbLeft.classList.remove('active');
        });
        inputEnd.addEventListener('touchstart', function () {
            thumbRight.classList.add('active');
        });
        inputEnd.addEventListener('touchend', function () {
            thumbRight.classList.remove('active');
        });
    }
    const slider = document.querySelector(".range-slider ");
    createslider(slider);
});
function createMarkers(google, map) {
    let infowindowElm = null;
    for (let i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
    }
    markers = [];
    let l = $('.estate:not(.hidden), .single-estate-holder').length;
    $('.estate:not(.hidden),.single-estate-holder').each((k, v) => {
        if ($(v).attr("data-lat") !== void 0 && $(v).attr("data-lat") != '' && $(v).attr("data-lng") !== void 0 && $(v).attr("data-lng") != "") {
            let content = $(v).parent().html();
            let latLng = { lat: parseFloat($(v).attr("data-lat")), lng: parseFloat($(v).attr("data-lng")) };
            let marker = new google.maps.Marker({
                position: latLng,
                icon: "/app/themes/lumber/static/gfx/pin.svg"
            });
            markers.push(marker);
            // marker.setMap(map);
            if ($(v).hasClass("single-estate-holder") == false) {
                let infowindow = new google.maps.InfoWindow({
                    content: `<div class="pop-up-map">${content}</div>`,
                    // disableAutoPan: true
                });
                $(v).on("click", ".location > div", (e) => {
                    $.scrollTo($("#map-holder").offset().top - ($("#main-header").height() + 20), 250);
                    map.panTo(latLng);
                    map.setZoom(17);
                    new google.maps.event.trigger(marker, 'click');
                });
                marker.addListener("click", (e) => {
                    if (infowindowElm != null)
                        infowindowElm.close();
                    infowindow.open({
                        anchor: marker,
                        map
                    });
                    infowindowElm = infowindow;
                });
            }
            if (l == k + 1) {
                const markerCluster = new MarkerClusterer({ map: map, markers: markers });
            }
        }
    });
}
